import {
     ThemeState, ThemeActionTypes, SET_THEME
} from "./types";

const initialState: ThemeState = {
    theme: process.env.REACT_APP_CODE_TENANT === undefined ? "" : process.env.REACT_APP_CODE_TENANT + "Theme",
};

export function themeReducer(
  state = initialState,
  action: ThemeActionTypes
): ThemeState {
    switch (action.type) {
        case SET_THEME:
            return {
                ...state,
                theme: action.payload as string,
            };
        default:
            return state;
  }
}
